// extracted by mini-css-extract-plugin
export var header = "header-module--header--knWBH";
export var span = "header-module--span--j8ROm";
export var ull = "header-module--ull--MFImd";
export var logo = "header-module--logo--y97xu";
export var header_h1 = "header-module--header_h1--S5obZ";